import { observable, action, runInAction } from "mobx";
import { message } from "antd";

class Store {
    @observable ES = [];
    @observable user = {};
    @observable BP = [];
    @observable HR = [];
    @observable isCloseMonth = true;
    @observable isView = false;
    @observable isCloseBP = true;
    @observable isSave = true;

    getAuth = (name, key) => {
        if (this.user.email === 'admin') return true;
        return this[name].includes(key);
    }

    @action
    getESAuth = async () => {
        try {

            let usersession = sessionStorage.getItem('user');
            let uj = JSON.parse(usersession);

            let userAuthName;

            if ((uj.email || '').includes('admin')) {
                userAuthName = uj.email;
            } else {
                userAuthName = (uj.email || '').split('_')[1];
            }

            let j = await fetch('/getMenuAuth?user=' + userAuthName, { credentials: 'include' });
            let res = await j.json();
            let auth = res.data || {};
            runInAction(() => {
                this.ES = ((auth.ES || {}).data || "").split(',') || [];
                this.BP = ((auth.BP || {}).data || "").split(',') || [];
                this.HR = ((auth.HR || {}).data || "").split(',') || [];
                this.isCloseMonth = auth.isCloseMonth;
                this.isCloseBP = auth.isCloseBP;
                this.isSave = auth.isSave;
                this.user = uj;
                this.isView = !!auth.isView;
            });

        } catch (error) {

            console.error(error);
            message.error('获取权限错误！');
        }

    }
}

const auth = new Store();

export default auth;


// WEBPACK FOOTER //
// ./src/store/auth/index.js